module.exports = __webpack_public_path__ + "static/media/york-9.82442756.jpg";